// adjust the relative path to where your file actually is
import styles from "../../EmployeeDetailPanel.module.css";

export default function RolePill ({ role, service, tags }) {
  const label = {
    CP: "Client Partner",
    CM: "Client Manager",
    SP: "Service Partner",
    SM: "Service Manager",
  };

  const roleClass =
    {
      CP: styles.chip_cp,
      CM: styles.chip_cm,
      SP: styles.chip_sp,
      SM: styles.chip_sm,
    }[role] || "";

  // Back-compat: if an array was passed, join it; otherwise use single service
  const serviceText =
    (typeof service === "string" && service) ||
    (Array.isArray(tags) && tags.length ? tags.join(", ") : "");

  const suffix =
    (role === "SP" || role === "SM") && serviceText ? `: ${serviceText}` : "";

  // show “: ACCTG, INDTAX, …” for SP/SM
  // const suffix =
  //   (role === "SP" || role === "SM") && Array.isArray(tags) && tags.length
  //     ? `: ${tags.join(", ")}`
  //     : "";

  return (
    <span className={`${styles.chip} ${roleClass}`}>
      {label[role] || role}
      {suffix}
    </span>
  );
};

